<template>
  <div>
    <section-header heading="2" ja="fiz2とは？"/>
    <div class="textArea">
      <p>
        「fiz2」はセガのプリクラ機です。<br>
        詳細は公式サイトをご確認ください。
      </p>
      <p><span class="textLink" @click="onfizWeb()">fiz2 公式サイト</span></p>
    </div>

    <section-header heading="2" ja="モーメントとは？"/>
    <div class="textArea">
      <p>fiz2では、「プリクラ(画像)」と同時に、「モーメント」と呼ばれる3秒間の動画を撮影することができます。</p>
      <p>
        モーメントには、下記の2種類があります。モーメントの種類は受付で選択可能です。<br>
        ※モーメントは、背景の色を変更することができません。
      </p>
      <p>
        ■シャッター前<br>
        プリクラのシャッターを切る前の3秒間を撮影します。<br>
        ■シャッター前後<br>
        プリクラのシャッターを切る前後1.5秒間を撮影します。
      </p>
    </div>

    <section-header heading="2" ja="fiz2を遊べるお店は？"/>
    <div class="textArea">
      <p>
        遊べるお店は<span class="textLink" @click="onfizLocation()">店舗検索</span>からご確認ください。
      </p>
    </div>
    <sub-btn @click="onAboutFiz()">戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import SubBtn from '@/components/SubBtn.vue'

export default {
  name: "AboutFiz01",
  components: {
    SectionHeader,
    SubBtn
  },
  methods: {
    onAboutFiz() {
      this.$router.push("/AboutFiz")
    },
    onfizWeb() {
      window.open("https://puri.sega.jp/", "_blank")
    },
    onfizLocation() {
      window.open("https://puri.sega.jp/location-map/?id=99", "_blank")
    }
  }
}
</script>

<style lang="scss" scoped>
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p {
    margin-top: 1em;
  }
}
.textLink { color: #DA2240; }
</style>
